import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { Lead } from '@adornis/digitale-helden-shared/db/Lead.js';
import {
  ActionTokenData,
  TokenAction,
} from '@adornis/digitale-helden-shared/features/action-tokens/db/ActionTokenData.js';
import { sendDigitaleHeldenMail } from '@adornis/digitale-helden-shared/features/mailing/server/mailer.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { createActionToken } from '../../features/action-tokens/db/createActionToken.js';
import { leadOptInTemplate } from '../../features/mailing/server/templates/lead-opt-in-template.js';

function getDeploymentPrefix() {
  const deployment = baseConfig.get('DEPLOYMENT');
  switch (deployment) {
    case 'development':
      return `https://lasdigitale-helden-michi-campus-runtime.nexus.adornis.de/`;
    case 'qa':
      return `https://digitale-helden-campus.qa.adornis.de/`;
    case 'staging':
      return `https://digitale-helden-campus.staging.adornis.de/`;
    case 'production':
      return `https://campus.digitale-helden.de/`;
  }
}

export const sendLeadDOIMail = registerMutation({
  type: () => String,
  operationName: 'sendLeadDOIMail',
  resolve: (lead: Lead, createAccount: boolean) => {
    return async () => {
      const token = new ActionTokenData({ action: TokenAction.DOI, lead, createAccount });
      const tokenId = await createActionToken(token)();

      const url = new URL(`${getDeploymentPrefix()}action`);
      const params = new URLSearchParams({ tokenId });
      url.search = params.toString();

      await sendDigitaleHeldenMail({
        message: async (webversionLink: string) =>
          await Message.compose(
            await leadOptInTemplate({
              accessLink: url.toString(),
              firstName: lead.firstName ?? '',
              webmailLink: webversionLink,
              redirectURL: 'https://digitale-helden.de/',
            }),
          ),
        recipients: new Recipient([lead.email]),
      });
    };
  },
  params: [
    { name: 'lead', type: () => Lead },
    { name: 'createAccount', type: () => Boolean },
  ],
});
